import { END_SESSION } from '../actions/authActions';
import { SET_VESTING_PROFILES } from '../actions/vestingProfileActions';
import { UNSUBSCRIBE_CURRENT_ACCOUNT } from '../actions/currentAccountActions';

const DEFAULT_STATE = [];

export default function vestingProfilesReducer(state = DEFAULT_STATE, { type, payload }) {
  switch (type) {
    case END_SESSION:
    case UNSUBSCRIBE_CURRENT_ACCOUNT:
      return DEFAULT_STATE;
    case SET_VESTING_PROFILES:
      return payload || DEFAULT_STATE;
    default:
      return state;
  }
}
